import { Link } from "react-router-dom";
import { Lock, Unlock, Rocket, Inbox, Send, Clock, Calendar as CalIcon, Package } from "lucide-react";
import Countdown from "./Countdown";
import { STATE_LABEL, STATE_PILL_CLASS, COVER_THEMES, formatDate } from "../lib/constants";

import { _t } from "@/lib/i18n";
export default function CapsuleCard({ capsule, viewerRole }) {
  const role = viewerRole || capsule.role;
  const isRecipient = role === "recipient";
  const state = capsule.state;
  const coverClass = COVER_THEMES.find((t) => t.id === capsule.cover_theme)?.className || "cover-orbit";

  return (
    <Link
      to={state === "BOZZA" && !isRecipient ? `/wizard/${capsule.id}` : `/capsule/${capsule.id}`}
      data-testid={`capsule-card-${capsule.id}`}
      className={`tc-card block group`}
    >
      <div className={`${coverClass} h-24 relative`}>
        <div className="absolute inset-0 flex items-start justify-between p-4">
          <div className="flex items-center gap-2 text-[11px] uppercase tracking-[0.15em] text-white/70">
            {isRecipient ? <><Inbox className="w-3 h-3" />{" "}{_t("Ricevuta")}</> : <><Send className="w-3 h-3" />{" "}{_t("Inviata")}</>}
          </div>
          <span className={`pill ${STATE_PILL_CLASS[state] || "pill-bozza"}`}>
            {state === "DISPONIBILE" && !isRecipient ? _t("Consegnata") :
              state === "DISPONIBILE" ? <><Unlock className="w-3 h-3" />{" "}{_t("Pronta")}</> :
              state === "APERTA" ? <><Unlock className="w-3 h-3" />{" "}{_t("Aperta")}</> :
              state === "IN_VIAGGIO" ? <><Rocket className="w-3 h-3" />{" "}{_t("In viaggio")}</> :
              state === "RIPENSAMENTO_24H" ? <><Clock className="w-3 h-3" />{" "}{_t("Ripensamento")}</> :
              state === "BOZZA" ? <><Package className="w-3 h-3" />{" "}{_t("Bozza")}</> :
              STATE_LABEL[state]}
          </span>
        </div>
      </div>

      <div className="p-6">
        <h3 className="font-display text-2xl text-white leading-tight mb-2 group-hover:text-[#FF5722] transition-colors duration-500">
          {capsule.title || _t("Capsula senza titolo")}
        </h3>
        {capsule.description && (
          <p className="text-sm text-white/60 line-clamp-2 mb-3">{capsule.description}</p>
        )}
        <div className="text-xs text-white/50 space-y-1 mb-4">
          {capsule.open_at && (
            <div className="flex items-center gap-2"><CalIcon className="w-3.5 h-3.5" />{" "}{_t("Apertura:")}{" "}{formatDate(capsule.open_at)}</div>
          )}
          <div>{_t("Destinatari: {0} · Contenuti: {1}", capsule.recipients_count, capsule.content_count)}</div>
        </div>

        {state === "RIPENSAMENTO_24H" && capsule.reconsideration_ends_at && (
          <div className="pt-3 border-t border-white/5">
            <div className="text-[10px] uppercase tracking-[0.2em] text-white/40 mb-1.5">{_t("Puoi annullare entro")}</div>
            <Countdown target={capsule.reconsideration_ends_at} size="sm" />
          </div>
        )}
        {state === "IN_VIAGGIO" && capsule.open_at && (
          <div className="pt-3 border-t border-white/5">
            <div className="text-[10px] uppercase tracking-[0.2em] text-white/40 mb-1.5">{_t("Manca all'apertura")}</div>
            <Countdown target={capsule.open_at} size="sm" />
          </div>
        )}
        {state === "DISPONIBILE" && isRecipient && (
          <div className="pt-3 border-t border-white/5">
            <div className="text-[11px] text-[#FF5722] font-medium uppercase tracking-[0.15em]">{_t("Il momento è arrivato ↗")}</div>
          </div>
        )}
      </div>
    </Link>
  );
}
